import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import HistoryCard from "./HistoryCard";
import { DeleteAllSanadHistory, getHistory } from "../../services/user/user";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import { Confirm, Alert } from "../../utils/alert";
import { AnimatePresence, motion } from "framer-motion"; // Import Framer Motion
import { convertToJalali } from "../../utils/convertToJalali";
import { useTranslation } from "react-i18next";

function History() {
  const [historyList, setHistoryList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
  const fetchData = async () => {
    try {
      const response = await getHistory();
      setHistoryList(response.data);
      setIsLoading(false);
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formatPrice = (price) => {
    return Number(price).toLocaleString();
  };

  // Handler for removing the deleted item from the list
  const handleDelete = (id) => {
    const updatedList = historyList.filter((item) => item.idstrsanad !== id);
    setHistoryList(updatedList); // Update the state to remove the deleted item
  };

  const handleDeleteAllHistory = async () => {
    const { value } = await Confirm(
      t("History.delT"),
      (t("History.delQ"))
    );
    if (value) {
      try {
        await DeleteAllSanadHistory();
        setHistoryList([]); // Clear the list after deletion
        setIsLoading(false);
        Alert(t("Progress.DeleteT"), t("Progress.Deletesuccess"), "");
      } catch (error) {
        Alert(t("Progrss.err"), error?.response?.data, "");
      }
    }
  };

  return (
    <Box sx={{ marginBottom: "8rem" }}>
      {isLoading ? (
        <Box
          sx={{
            height: "50vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="primary" size={70} />
        </Box>
      ) : historyList.length === 0 ? (
        <Box
          sx={{
            minHeight: "60vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <InfoIcon
            fontSize="large"
            sx={{ marginBottom: ".45rem", color: "#929292" }}
          />
          <Typography variant="h2" color="textSecondary" textAlign="center">
          {(t("History.empty"))}
          </Typography>
        </Box>
      ) : (
        <AnimatePresence>
          {historyList.map((history, index) => (
            <motion.div
              key={history.idstrsanad}
              initial={{ opacity: 0, x: 100 }} // Initial animation state
              animate={{ opacity: 1, x: 0 }} // Animation on mount
              exit={{ opacity: 0, x: -100 }} // Exit animation on unmount
              transition={{
                duration: 0.7, // Duration for initial and animate
                delay: 0.1 * (index + 1), // Add a delay for each subsequent item based on its index

                exit: { duration: 1.5 }, // Longer duration for exit animation
              }}
            >
              <HistoryCard
                namesanad={history.namesanad}
                datesabt={convertToJalali(history.datesabt)}
                price={formatPrice(history.price)}
                idstrsanad={history.idstrsanad}
                onDelete={handleDelete}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      )}

      {historyList.length > 0 && (
        <Box
          sx={{
            padding: ".75rem",
            width: "45%",
            position: "fixed",
            bottom: "12vh",
          }}
        >
          <Button
            variant="contained"
            color="error"
            onClick={handleDeleteAllHistory}
            sx={{ padding: "15px 15px", borderRadius: "15px" }}
          >
            <Typography variant="h5" sx={{ marginRight: "10px" }}>
              {t("Upload.Deleteall")}
            </Typography>
            <DeleteIcon size="large" />
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default History;
